<template>

    <div class="action">
        <div class="action-body">
            <v-icon class="mr-15" :symbol="'action-' + action.type" :size="40" :radius="3" />
            <div class="info">
                <span class="name">{{ action.name }}</span>
                <span class="desc">{{ action.desc }}</span>
            </div>
        </div>
        <div class="action-footer">
            <v-button size="sm" btn-style="secondary" :loading="loading">Add</v-button>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .action {
        align-items: center;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        padding: 10px 15px;
        transition: border-color .3s;
        &:hover {
            border-color: $color-text;
        }
        &:last-child {
            margin-bottom: 0;
        }
        .action-body {
            align-items: center;
            display: flex;
            span {
                color: $color-text;
                display: block;
                line-height: normal;
                margin-bottom: 2px;
            }
            .name {
                @include font-medium(15px);
            }
            .desc {
                @include font-medium(12px);
            }
        }
    }

</style>

<script>

export default {

    props: {
        action: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

}

</script>
